import React from "react";
import { connect } from "react-redux";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  Input,
  Select,
  CheckBox,
  Icon,
  DatePicker,
} from "../../components";
import { axios, Constants, Globals, Format, ENV } from "../../utils";
import { Branch, Warehouse, Category, Brand } from "../../services";
import NumberFormat from "react-number-format";
import SearchIcon from '../../assets/icons/search.png';
import PrinterIcon from '../../assets/icons/printer.png';
import moment from "moment";

const INITIAL_TABLE_MSG = 'Realice una búsqueda para ver los resultados';
const EMPTY_TABLE_MSG = 'No hay registros';

// Headers para ambos modos
const HEADER_BY_ORDERS = [
  "ID Pedido",
  "Código\nProducto",
  "Nombre\nProducto",
  "Vendedor",
  "Cantidad\nVendida",
  "Monto\nTotal",
];

const HEADER_GROUPED = [
  "Código\nProducto",
  "Nombre\nProducto",
  "Vendedor",
  "Categoría\nProducto",
  "Marca\nProducto",
  "Modelo\nProducto",
  "Cantidad\nVendida",
  "Monto\nTotal",
  "Cantidad\nPedidos",
];

class ReportProductsSoldBySeller extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      last_page: 1,
      data: [],
      user: null,
      emptyMessage: INITIAL_TABLE_MSG,
      form: {
        search_order: "",
        search: "",
        user_id: this.props.user.id,
        seller_id: "",
        for_orders: false, // por defecto false (trase solo vendedores)
      },
      user_id: this.props.user.id,
      role: this.props.user.role,
      dates: {
        minDate: "",
        maxDate: ""
      },
      sellers: [],
      searchTimeout: null,
    };
  }

  abortController = new AbortController();

  componentDidMount() {
    this.getSellers();
    this.syncModeWithPath(false); // No carga datos inicialmente
  }

  componentDidUpdate(prevProps) {
    if (this.props.location?.pathname !== prevProps.location?.pathname) {
      // la ruta cambió → sincroniza modo
      this.syncModeWithPath(false);
    }
  }

  syncModeWithPath = (autoLoad = false) => {
    const path = this.props.location?.pathname || '';
    const isForOrders = path.includes('productssoldbyOrders');

    this.setState(prevState => ({
      // resetea paginación y datos visibles
      page: 1,
      last_page: 1,
      data: [],
      emptyMessage: INITIAL_TABLE_MSG,
      // limpia filtros pero conserva user_id y ajusta for_orders según la ruta
      form: {
        ...prevState.form,
        search: "",
        search_order: "",
        seller_id: "",
        since: undefined,
        until: undefined,
        user_id: this.props.user.id,
        for_orders: isForOrders,
      }
    }), () => {
      if (autoLoad) this.getData();
    });
  };

  componentWillUnmount() {
    this.abortController.abort();
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if (isText) {
      const searchTimeout = setTimeout(() => {
        this.getData(1);
      }, 700);
      this.setState({ searchTimeout });
    } else {
      this.getData(1);
    }
  };

  load = () => {
    this.getData();
  };

  getSellers = () => {
    let { form } = this.state;
    const { user } = this.props;

    axios
      .post("admin/reports/sellers-web", { user_id: user.id, only_sellers: true })
      .then(res => {
        this.setState({
          sellers: res.data.sellers,
        });
      })
      .catch(err => {
        Globals.showError();
      });
  }

  getData = async (resetPage = null) => {
    let { page, form } = this.state;

    if (typeof resetPage === "number") {
      page = resetPage;
    }

    Globals.setLoading();
    await axios
      .post("admin/reports/productssoldbyseller?page=" + page, form)
      .then(res => {
        this.setState({
          emptyMessage: EMPTY_TABLE_MSG,
          last_page: res.data.products.last_page,
          data: res.data.products.data,
        });
        Globals.quitLoading();
      })
      .catch(err => {
        Globals.showError();
      });
  };

  change = e => {
    const { name, value, type } = e.target;
    const isText = !['select-one', 'select-multiple', 'checkbox', 'radio'].includes(type);
    this.setState({
      form: {
        ...this.state.form,
        [name]: value
      }
    }, () => {
      this.autoFilter(isText);
    });
  };

  handleChangeSellers = (event) => {
    const selectedValue = event.target.value;
    const selectedLabel = this.state.sellers.find((seller) => seller.id == selectedValue)?.name;
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        seller_id: selectedValue,
        seller_label: selectedLabel,
      }
    }), () => {
      this.autoFilter(false);
    });
  }

  returnState = async () => {
    const keepForOrders = this.state.form.for_orders; // conservar
    await this.setState(state => ({
      ...state,
      emptyMessage: INITIAL_TABLE_MSG,
      data: [],
      page: 1,
      last_page: 1,
      form: {
        search_order: "",
        search: "",
        user_id: this.props.user.id,
        seller_id: "",
        for_orders: keepForOrders,
      }
    }));
    // await this.load();
  };

  print = (data) => {
    let { form } = Globals.copy(this.state);
    form.download = true;

    axios
      .post("admin/reports/productssoldbyseller", form)
      .then(res => {
        if (res.data.url_storage) {
          const url = `${ENV.BasePublic}${res.data.url_storage}`;
          const win = window.open(url, "_blank");
          win.focus();
        }
        else {
          Globals.showError('Ha ocurrido un error');
        }
      })
      .catch(err => {
        Globals.showError();
      });

  };

  render() {
    const { data, emptyMessage, last_page, page, form } = this.state;
    const usingOrdersLayout = !!form.for_orders;

    return (
      <Menu history={this.props.history}>
        <div id="products" className="new-reports">
          <div className="row">
            <div className="col-md-3">
              <Input
                color=" "
                name="search"
                label="Búsqueda"
                className="filter"
                onChange={this.change}
                value={form.search}
                placeholder="Por nombre o código de producto"
              />
            </div>

            {usingOrdersLayout && (
              <div className="col-md-2">
                <Input
                  color=" "
                  name="search_order"
                  label="Búsqueda por pedido"
                  className="filter"
                  onChange={this.change}
                  value={form.search_order}
                  placeholder="Por ID de pedido"
                />
              </div>
            )}

            <div className="col-md-2">
              <Select
                color="white"
                name="seller_id"
                label="Vendedor"
                className="filter"
                defaultname="Todos"
                disabledFirst="false"
                onChange={this.handleChangeSellers}
                value={form.seller_id}
                options={this.state.sellers.map(Item => ({
                  value: Item.id,
                  label: Item.name
                }))}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                minDate={this.state.dates.minDate}
                value={form.since}
                onChange={value => {
                  this.setState(state => ({
                    form: {
                      ...state.form,
                      since: value
                    }
                  }), () => this.autoFilter(false));
                }}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                maxDate={this.state.dates.maxDate}
                value={form.until}
                onChange={value => {
                  this.setState(state => ({
                    form: {
                      ...state.form,
                      until: value
                    }
                  }), () => this.autoFilter(false));
                }}
              />
            </div>

            <div className="col-md-4">
              <div className="container-buttons">
                <Button className="btn-align-bottom btn-filter" color=" " onClick={this.returnState}>
                  <span>Limpiar</span>
                </Button>
              </div>
            </div>
          </div>

          <Table
            data={data.length}
            title={usingOrdersLayout
              ? 'Reporte de productos vendidos por pedidos'
              : 'Reporte de productos vendidos por vendedor'}
            emptyMessage={emptyMessage}
            header={usingOrdersLayout ? HEADER_BY_ORDERS : HEADER_GROUPED}
            right={
              <Button
                title="Imprimir"
                small="true"
                onClick={() => this.print(data)}
              >
                <img src={PrinterIcon} style={{ width: 24 }} alt="Imprimir" />
              </Button>
            }
          >
            {data.map((i, index) => {
              if (usingOrdersLayout) {
                // Vista por pedidos (for_orders = true)
                return (
                  <tr key={index}>
                    <td style={{ maxWidth: 'none' }}>{i.order_correlative_number}</td>
                    <td style={{ maxWidth: 'none' }}>{i.product_code}</td>
                    <td style={{ maxWidth: 'none' }}>{i.product_name}</td>
                    <td style={{ maxWidth: 'none' }}>{i.seller}</td>
                    <td style={{ maxWidth: 'none' }}>{Number(i.quantity_sold)}</td>
                    <td style={{ maxWidth: 'none' }}>
                      {parseFloat(Number(i.amount_total || 0)).toFixed(2)}
                    </td>
                  </tr>
                );
              } else {
                // Vista agrupada original
                return (
                  <tr key={index}>
                    <td style={{ maxWidth: 'none' }}>{i.product_code}</td>
                    <td style={{ maxWidth: 'none' }}>{i.product_name}</td>
                    <td style={{ maxWidth: 'none' }}>{i.seller}</td>
                    <td style={{ maxWidth: 'none' }}>{i.product_category}</td>
                    <td style={{ maxWidth: 'none' }}>{i.product_brand}</td>
                    <td style={{ maxWidth: 'none' }}>{i.product_model}</td>
                    <td style={{ maxWidth: 'none' }}>{Number(i.quantity_sold)}</td>
                    <td style={{ maxWidth: 'none' }}>
                      {parseFloat(Number(i.amount_total || 0)).toFixed(2)}
                    </td>
                    <td style={{ maxWidth: 'none' }}>{Number(i.order_quantity || 0)}</td>
                  </tr>
                );
              }
            })}
          </Table>

          <Pagination
            pages={last_page}
            active={page}
            onChange={async newPage => {
              await this.setState({ page: newPage });
              this.load();
            }}
          />

        </div>
      </Menu>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(ReportProductsSoldBySeller);
